import { render, staticRenderFns } from "./PriceConversation.vue?vue&type=template&id=b14ef968&"
import script from "./PriceConversation.vue?vue&type=script&lang=js&"
export * from "./PriceConversation.vue?vue&type=script&lang=js&"
import style0 from "./PriceConversation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports